import { useEffect, useState } from "react";

export default function useResizeListener(limit: number) {
    const getMatches = () => window.matchMedia(`(max-width: ${limit}px)`).matches;
    const [lessThan, setLessThan] = useState(getMatches);

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${limit}px)`);
        const updateMatches = () => setLessThan(mediaQuery.matches);

        updateMatches();
        mediaQuery.addEventListener("change", updateMatches);
        return () => {
            mediaQuery.removeEventListener("change", updateMatches);
        };
    }, [limit]);

    return lessThan;
}
